import { Controller } from '@hotwired/stimulus';

/**
 * Tool launcher - the popover grid of Meerkeep tools. The browser opens and closes it (popovertarget, outside
 * click, Escape); this keeps every invoking button's aria-expanded in sync and moves focus into the grid on open.
 */
export default class extends Controller {
  sync (event) {
    const open = event.newState === 'open';
    document.querySelectorAll(`[popovertarget="${this.element.id}"]`).forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open) (this.element.querySelector('[aria-current]') || this.element.querySelector('a'))?.focus();
  }
}
